import { useMemo, useState, useCallback, useRef, useEffect } from 'react';
// import WaveSurfer from 'wavesurfer.js'
// import Regions from 'wavesurfer.js/dist/plugins/regions.esm.js'
// import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js';
import { useWavesurfer } from '@wavesurfer/react'
import Timeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
//import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline';
import serverURL from '../../config/serverConfig';


export default function Player(props){

    const formatTime = (seconds) => [seconds / 60, seconds % 60].map((v) => `0${Math.floor(v)}`.slice(-2)).join(':')

    const containerRef = useRef(null)
    const [urlIndex, setUrlIndex] = useState(0)
    const [audioUrl, setAudioUrl] = useState(null);

    //console.log("Player render, track:", props.track)

    const getAudioUrl = async (key) => {
      const res = await fetch(`${serverURL}presigned-download?key=${encodeURIComponent(key)}`);
      const { url } = await res.json();
      return url;
      // const text = await res.text();
      // console.log("RAW RESPONSE:", text);
    };
  
    useEffect(() => {
      async function load() {
        console.log(props.track)
        const url = await getAudioUrl(props.track.key);
        setAudioUrl(url);
        //console.log("Audio URL set:", url);
      }

      if (props.track?.key) {
        load();
      }
    }, [props.track]);

    const { wavesurfer, isPlaying, currentTime } = useWavesurfer({
      container: containerRef,
      height: 40,
      barWidth: 1,
      barHeight: 2,
      //url: '/audio/audio.mp3',
      url: audioUrl,
      plugins: useMemo(() => [Timeline.create()], []),
    //   plugins:  {
    //     plugin: Timeline,
    //     key: "timeline",
    //     options: {
    //        container: containerRef
    //     }
    //     },
      waveColor: "rgb(0, 0, 0)",
      progressColor: "rgb(70,70,70)",
      //progressColor: "rgb(255,238,0)",

      dragToSeek: true,
      cursorWidth: 4,
      mediaControls: false,
      interact: true,
    })
    
      const onPlayPause = useCallback(() => {
        wavesurfer && wavesurfer.playPause()
      }, [wavesurfer])


      useEffect(() => {
        wavesurfer && wavesurfer.playPause()
    }, [props.isPlaying])

    useEffect(() => {
        if (wavesurfer && props.stopCount > 0) {
            wavesurfer.stop()
        }
    }, [props.stopCount])

    useEffect(() => {
        if (wavesurfer && props.replayCount > 0) {
            wavesurfer.seekTo(0)
            wavesurfer.play()
        }
    }, [props.replayCount])
    
/////////////////////////
if(props.selected==props.trackNum){
  wavesurfer && wavesurfer.setMuted(false)
} else {
  wavesurfer && wavesurfer.setMuted(true)
 // console.log("mute")
}
useEffect(() => {
  //console.log(props.selected)
  if(props.selected==props.trackNum){
      wavesurfer && wavesurfer.setMuted(false)
      //getCurrentTime
  } else {
      wavesurfer && wavesurfer.setMuted(true)
      //console.log("mute")
      //setScrollTime
  }
}, [props.selected])
/////////////////////

      //const wsRegions = wavesurfer.registerPlugin(RegionsPlugin.create())

    return(
        <div className={props.selected==props.trackNum ? "activeTrack surfer" : "notActiveTrack surfer"}>
                <div className='trackTitleRow text-xs py-1'>
                    <span>{props.track.title}</span>
                    <span className='mr-2'>{new Date(props.track.upload_date).toLocaleDateString()}</span>
                </div>
                <div ref={containerRef} />
  
          {/* <p>Current audio: {audioUrls[urlIndex]}</p> */}
  
        <p className="text-xs pt-1 justify-self-center">{formatTime(currentTime)}</p>
      </div>
    )
}